export default "__VITE_ASSET__DqxuSOBB__"